<template>
  <label
    class="checkbox"
    @click.prevent="emit('update:isChecked', !isChecked)"
  >
    <input
      type="checkbox"
      :checked="isChecked"
    >
    <div class="checkbox__tick multi-select__label">
      <div class="checkbox__tick--svg">
        <ChecktickSVG />
      </div>
      <slot />
    </div>
  </label>
</template>


<script setup>
import ChecktickSVG from '@/assets/images/global/checkbox.svg?component';

const emit = defineEmits(['update:isChecked']);

const isChecked = defineModel('isChecked', {
	type: Boolean,
	default: false
});

defineProps({
	value: {
		type: [String, Number, Array, Object],
		default: ''
	}
});
</script>
